module.exports = __webpack_public_path__ + "static/media/balance-m.98784b79.svg";